/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Bot_StatusInputs */

const tr_landing_telegram_mock_bot_status = /** @type {(inputs: Landing_Telegram_Mock_Bot_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bot · çevrimiçi`)
};

const en_landing_telegram_mock_bot_status = /** @type {(inputs: Landing_Telegram_Mock_Bot_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bot · online`)
};

const de_landing_telegram_mock_bot_status = /** @type {(inputs: Landing_Telegram_Mock_Bot_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bot · online`)
};

const ru_landing_telegram_mock_bot_status = /** @type {(inputs: Landing_Telegram_Mock_Bot_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`бот · в сети`)
};

/**
* | output |
* | --- |
* | "bot · online" |
*
* @param {Landing_Telegram_Mock_Bot_StatusInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_bot_status = /** @type {((inputs?: Landing_Telegram_Mock_Bot_StatusInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Bot_StatusInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_bot_status(inputs)
	if (locale === "de") return de_landing_telegram_mock_bot_status(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_bot_status(inputs)
	return tr_landing_telegram_mock_bot_status(inputs)
});